module.exports = __webpack_public_path__ + "img/spotify-icon-black.b818d523.png";